import { SearchQuery } from 'modules/domains';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { isUndefined } from 'utils/tsHelpers';
import { useCurrentProjectId } from 'utils/hooks/useCurrentProjectId';
import { useCatalogName } from './useCatalogName';
import { useGetCatalogFieldDetails } from './useGetCatalogFieldDetails';
import { useCatalogPreviewContext } from '../contexts/CatalogPreviewContext';
import { useCatalogQueryContext } from '../../../contexts/catalogQuery';

export const useSubmitForApply = () => {
  const catalogFieldDetails = useGetCatalogFieldDetails();
  const { closePreview } = useCatalogPreviewContext();
  const { onClose } = useCatalogQueryContext();
  const catalogName = useCatalogName();
  const projectId = useCurrentProjectId();

  return (searchQuery: CompleteQuery) => {
    if (isUndefined(catalogName)) return;
    onClose({
      catalogQuery: {
        catalogName,
        projectId,
        searchQuery: searchQuery as unknown as SearchQuery,
      },
      ...(!!catalogFieldDetails?.field && {
        catalogField: catalogFieldDetails.field,
      }),
    });
    closePreview();
  };
};
